import withRoot from "./modules/withRoot";
import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import ProductCategories from "./modules/views/ProductCategories";
import ProductSmokingHero from "./modules/views/ProductSmokingHero";
import ProductHero from "./modules/views/ProductHero";
import ProductValues from "./modules/views/ProductValues";
import ProductHowItWorks from "./modules/views/ProductHowItWorks";
import Employees from "./modules/views/Employees/Employees";
import AppAppBar from "./modules/views/AppAppBar";
import Slider from "./modules/views/Slider";
import ArticlesNew from "./modules/views/ArticlesNew";
import Icons from "./modules/views/Icons";
import Footer from "./modules/views/Footer";
import Preloader from "./modules/views/Preloader";
import ScrollReveal from "./modules/views/ScrollReveal";
import TruckScroller from "./modules/views/TruckScroller";

function App({ history }) {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  return <Index />;
}

function Index() {
  return (
    <React.Fragment>
      <Preloader />
      <TruckScroller />
      <AppAppBar />
      <ProductHero />
      <ScrollReveal direction="up" duration={1}>
        <ProductValues />
      </ScrollReveal>
      <ScrollReveal direction="scale" duration={1}>
        <ProductCategories />
      </ScrollReveal>
      <ScrollReveal direction="up" duration={0.9}>
        <Icons />
      </ScrollReveal>
      <ScrollReveal direction="up" duration={1}>
        <ProductHowItWorks />
      </ScrollReveal>
      <ScrollReveal direction="left" duration={1}>
        <Employees />
      </ScrollReveal>
      <ScrollReveal direction="up" duration={1}>
        <ArticlesNew />
      </ScrollReveal>
      <ScrollReveal direction="scale" duration={0.9}>
        <Slider />
      </ScrollReveal>
      <ScrollReveal direction="up" duration={0.8}>
        <ProductSmokingHero />
      </ScrollReveal>
      <Footer />
    </React.Fragment>
  );
}

export default withRoot(withRouter(App));
